module.exports = __webpack_public_path__ + "img/globe.50143649.svg";